<template>
  <div class="container">
    <!-- <div class="top">
      <van-cell
        v-if="defaultAddress.isDefault"
        :title="
          defaultAddress.isDefault
            ? '' + defaultAddress.name + ' ' + defaultAddress.tel
            : isDefaultAddress
        "
        :label="defaultAddress.address"
        border
        center
        clickable
        ><template slot="default">
          <van-tag type="danger">默认地址</van-tag>
        </template>
      </van-cell>
      <van-cell
        v-if="!defaultAddress.isDefault"
        :title="isDefaultAddress"
        border
        center
        clickable
      >
        <template slot="default">
          <van-tag type="danger">默认地址</van-tag>
        </template>
      </van-cell>
    </div> -->
    <div v-if="list.length > 0" class="scroll">
      <!-- <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        style="overflow: auto; height: 100%"
      > -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="到底啦~"
        @load="onLoad"
        :immediate-check="false"
      >
        <div v-for="item in list" :key="item.id" class="flex_address">
          <van-cell
            :label="item.province + item.city + item.district + item.details"
            :border="false"
          >
            <template #title>
              <span class="custom-title">{{
                item.name + " " + item.cellPhone
              }}</span>
              <van-tag
                type="danger"
                v-if="item.isDefault"
                style="margin-left: 2vw"
                >默认</van-tag
              >
            </template>
          </van-cell>
          <div @click="onEdit(item)" style="color: #969799;">
            <van-icon name="edit" size="20"/>
            <!-- <img src="../../../../assets/images/del.png" alt="" /> -->
          </div>
          <!-- <van-icon
              name="delete"
              size="20"
              style="margin-right: 3vw"
              @click="onDelete(item.id)"
            /> -->
        </div>
      </van-list>
      <!-- </van-pull-refresh> -->
    </div>
    <div v-if="list.length == 0" class="addresslistEmpty">
      <van-empty description="什么都没有哦" />
    </div>
    <div class="bottomBackground">
      <van-button type="danger" class="bottomBtn" @click="onAdd"
        >新建收货地址</van-button
      >
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  AddressList,
  Toast,
  Cell,
  Panel,
  Icon,
  Tag,
  Button,
  List,
  PullRefresh,
  Overlay,
  Dialog
} from "vant";
import service from "../../../api/user/address";
import loading from "../../../components/loading/loading";
export default {
  components: {
    [AddressList.name]: AddressList,
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [Panel.name]: Panel,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Overlay.name]: Overlay,
    [Dialog.Component.name]: Dialog.Component,
    loading
  },
  data() {
    return {
      isLoading: true, //loading状态
      chosenAddressId: "1",
      list: [],
      disabledlist: [],
      defaultAddress: {},
      isSelecting: false,
      isDefaultAddress: "请设置默认地址",
      page: 1,
      pageSize: 8,
      loading: false,
      finished: false,
      refreshing: false
    };
  },
  computed: {},
  methods: {
    onEdit(item) {
      this.$router.push({
        name: "addressedit",
        query: { id: item.id, type: "update" }
      });
    },
    // getAddress() {
    //   service.getDefault().then((response) => {
    //     if (response.statusCode == 200 && response.data !== null) {
    //       // this.defaultAddress = true;
    //       this.defaultAddress = {
    //         name: response.data.name,
    //         tel: response.data.cellPhone,
    //         address:
    //           response.data.province +
    //           response.data.city +
    //           response.data.district +
    //           response.data.details,
    //         id: response.data.id,
    //         isDefault: response.data.isDefault
    //       };

    //       this.addressId = response.data.id;
    //     }
    //   });
    // },
    init() {
      this.page = 1;
      this.addressList().then((addressList) => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        if (addressList.items.length !== 0) {
          this.list = addressList.items;
          if (addressList.totalCount <= 8) {
            this.finished = true;
            this.loading = false;
          } else {
            this.onLoad();
          }
        } else {
          this.list = [];
          this.defaultAddress.isDefault = false;
        }
      });
    },
    onLoad() {
      this.page++;
      this.loading = true;
      this.addressList().then((addressList) => {
        this.list = this.list.concat(addressList.items);
        this.loading = false;
        if (addressList.totalCount <= this.list.length) {
          this.finished = true;
        }else{
          this.onLoad()
        }
      });
    },  
    // onRefresh() {
    //   // 清空列表数据
    //   this.page = 1;
    //   this.finished = false;
    //   // 重新加载数据
    //   // 将 loading 设置为 true，表示处于加载状态
    //   this.loading = true;
    //   this.list = [];
    //   this.isLoading = true;
    //   this.addressList().then((addressList) => {
    //     setTimeout(() => {
    //       this.isLoading = false;
    //     }, 500);
    //     if (addressList.items.length !== 0) {
    //       this.list = addressList.items;
    //     } else {
    //       this.list = [];
    //     }
    //     if (addressList.totalCount < this.list.length) {
    //       this.finished = true;
    //     }
    //     this.loading = false;
    //     //
    //     // this.refreshing = true;
    //     // this.onLoad();
    //   });
    // },
    addressList() {
      return new Promise((resolve, reject) => {
        service
          .getAddress(this.page, this.pageSize)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            // reject();
          });
      });
    },

    onAdd() {
      this.$router.push({
        name: "addressedit",
        query: { id: 0, type: "add" }
      });
    },
    onDelete(info) {
      //   this.list = this.list.filter(item => item.id !== info);
      Dialog.confirm({
        message: "确认删除么"
      })
        .then(() => {
          service
            .deleteAddress(info)
            .then((res) => {
              if (res.statusCode == 200) {
                Toast("删除成功");
                this.init();
              }
            })
            .catch((err) => {
              // Toast(err);
            });
        })
        .catch(() => {
          Toast("你已取消删除");
        });
    }
  },
  mounted() {
    this.init();
    // this.getAddress();
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  // position: fixed;
  // height: calc(100% - 12.7vw);
  min-height: 100vh;
  .van-overlay {
    z-index: 1000;
  }
  .top {
    border-bottom: 1px solid #f7f7f7;
  }
  .addresslistEmpty {
    .van-cell--center {
      padding: 4.66667vw 4.26667vw;
    }
  }
  .scroll {
    height: calc(100% - 2.3vw);
    overflow-y: auto;
    padding-bottom: 19.4vw;
  }
  .van-address-item__address {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 80vw;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 3.8vw;
  }
  .address_list {
    flex: 1;
    // margin-bottom: 16vw;
  }

  .van-address-item__name {
    font-size: 14px;
  }
  .van-cell__value {
    flex: none;
  }
}
.flex_address {
  display: flex;
  align-items: center;
  background: #fff;
  margin-bottom: 1vw;
  padding: 1vw 4.2vw 1vw 0;
  border-bottom: 1px solid #f7f7f7;
}
</style>